export default class TcSlider {
    constructor(container, setting) {
        this.wrapperWidth = 0;
        this.itemWidth = 0;
        this.items = [];
        this.track = null;
        this.trackWidth = 0;
        this.navDisabled = false;
        this.isStart = false;
        this.isEnd = false;
        this.startPosition = 0;
        this.trackPosition = 0;
        this.endPosition = 0;
        this.currentItemsCount = 0;
        this.initialItemsCount = 0;
        this.container = container;
        this.settings = setting;
        this.currentItemsCount = this.settings.items;
        this.setup();
    }
    setup() {
        this.setItemsCount();
        if (!this.buildUI()) {
            return;
        }
        this.createNavs();
        this.setTrackStartPosition();
        this.setupEvents();
    }
    setTrackStartPosition() {
        if (this.items.length === 1) {
            this.trackPosition = 0;
        }
        else {
            this.startPosition = 0;
            this.trackPosition = 0;
        }
        this.setTrackPosition();
    }
    setTrackPosition() {
        if (!this.track) {
            return;
        }
        this.track.style.transitionProperty = 'none';
        this.track.style.transform = `translate3d(${this.trackPosition}px,0,0)`;
    }
    next() {
        this.isEnd = Math.abs(this.trackPosition) === this.trackWidth - this.itemWidth * this.currentItemsCount;
        if (this.isEnd || this.items.length === 1) {
            return;
        }
        this.trackPosition -= this.itemWidth;
        this.move();
    }
    prev() {
        this.isStart = Math.abs(this.trackPosition) === 0;
        if (this.isStart || this.items.length === 1) {
            return;
        }
        this.trackPosition += this.itemWidth;
        this.move();
    }
    move() {
        if (!this.track) {
            return;
        }
        this.track.style.transition = `transform 300ms ease`;
        this.track.style.transform = `translate3d(${this.trackPosition}px,0,0)`;
    }
    setItemsCount() {
        const clientWidth = document.body.clientWidth;
        let brakePoint = null;
        let items = this.currentItemsCount;
        this.settings.breakpoints.forEach((bp) => {
            if (!brakePoint && bp.maxWidth >= clientWidth) {
                brakePoint = bp;
                items = bp.items;
            }
            else if (bp.maxWidth >= clientWidth && (!brakePoint || brakePoint.maxWidth > clientWidth)) {
                brakePoint = bp;
                items = bp.items;
            }
        });
        if (!brakePoint && this.initialItemsCount > 0) {
            items = this.initialItemsCount;
        }
        this.currentItemsCount = items;
    }
    updateUI() {
        if (!this.track) {
            return;
        }
        this.setItemsCount();
        this.wrapperWidth = parseInt(window.getComputedStyle(this.container).getPropertyValue('width'));
        this.itemWidth = parseInt((this.wrapperWidth / this.currentItemsCount).toString());
        this.trackWidth = this.itemWidth * this.items.length;
        this.track.style.width = this.trackWidth + 'px';
        this.items.forEach((item) => {
            const itemHtml = item;
            itemHtml.style.width = this.itemWidth + 'px';
        });
        this.setTrackStartPosition();
    }
    setupEvents() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.intersectionRatio > 0) {
                    this.updateUI();
                }
            });
        }, { root: document.documentElement });
        observer.observe(this.container);
        let innerWidth = window.innerWidth;
        window.addEventListener('resize', () => {
            const newInnerWidth = window.innerWidth;
            if (innerWidth !== newInnerWidth) {
                this.updateUI();
            }
            innerWidth = newInnerWidth;
        }, false);
        if (!this.track) {
            return;
        }
        this.track.addEventListener('transitionstart', () => {
            this.isEnd = Math.abs(this.trackPosition) === this.trackWidth - this.itemWidth;
        });
        let xDown = null;
        let yDown = null;
        let xEnd = null;
        let yEnd = null;
        let xDiff = null;
        let yDiff = null;
        const touchEnd = (xUp, yUp) => {
            if (!xDown || !yDown) {
                return;
            }
            xDiff = xDown - xUp;
            yDiff = yDown - yUp;
            if (Math.abs(xDiff) > Math.abs(yDiff)) {
                if (xDiff > 30) {
                    this.next();
                }
                else if (xDiff < -30) {
                    this.prev();
                }
            }
            xDown = null;
            yDown = null;
        };
        this.track.addEventListener('mousedown', (evt) => {
            xDown = evt.clientX;
            yDown = evt.clientY;
        });
        this.track.addEventListener('mousemove', (evt) => {
            xEnd = evt.clientX;
            yEnd = evt.clientY;
        });
        this.track.addEventListener('mouseup', () => {
            if (xEnd && yEnd) {
                touchEnd(xEnd, yEnd);
                xEnd = null;
                yEnd = null;
            }
        });
        this.track.addEventListener('touchstart', (evt) => {
            xDown = evt.touches[0].clientX;
            yDown = evt.touches[0].clientY;
        });
        this.track.addEventListener('touchmove', (evt) => {
            xEnd = evt.touches[0].clientX;
            yEnd = evt.touches[0].clientY;
        });
        this.track.addEventListener('touchend', () => {
            if (xEnd && yEnd) {
                touchEnd(xEnd, yEnd);
                xEnd = null;
                yEnd = null;
            }
        });
    }
    buildUI() {
        this.container.classList.add('tc-slider');
        this.items = [...this.container.children];
        if (this.items.length === 0) {
            return false;
        }
        if (this.items.length <= this.currentItemsCount) {
            this.currentItemsCount = this.initialItemsCount = this.items.length;
        }
        else {
            this.initialItemsCount = this.settings.items;
        }
        this.wrapperWidth = parseInt(window.getComputedStyle(this.container).getPropertyValue('width'), 10);
        this.itemWidth = parseInt((this.wrapperWidth / this.currentItemsCount).toString());
        this.items.forEach((item) => {
            const itemHtml = item;
            itemHtml.classList.add('tc-slider__item');
            itemHtml.style.width = this.itemWidth + 'px';
            itemHtml.style.paddingRight = this.settings.gutter + 'px';
        });
        this.track = document.createElement('div');
        this.track.className = 'tc-slider__track';
        this.trackWidth = this.itemWidth * this.items.length;
        this.track.style.width = this.trackWidth + 'px';
        this.items.forEach((item) => {
            this.track?.appendChild(item);
        });
        const trackHolder = document.createElement('div');
        trackHolder.className = 'tc-slider__holder';
        trackHolder.appendChild(this.track);
        this.container.appendChild(trackHolder);
        return true;
    }
    createNavs() {
        if (this.items.length <= this.currentItemsCount || !this.settings.showNav) {
            return;
        }
        const prevNav = document.createElement('div');
        prevNav.className = 'tc-slider__nav tc-slider__nav--prev';
        prevNav.setAttribute('role', 'button');
        prevNav.addEventListener('click', () => {
            this.prev();
        });
        const nextNav = document.createElement('div');
        nextNav.className = 'tc-slider__nav tc-slider__nav--next';
        nextNav.setAttribute('role', 'button');
        nextNav.addEventListener('click', () => {
            this.next();
        });
        this.container.appendChild(prevNav);
        this.container.appendChild(nextNav);
    }
}
